const _excluded = ["passwordConfirm"];function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;} /* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';

import { RequestParams } from "../../../../utils/RequestParams";
import UsersAPI from "../../../../Users/UsersAPI";


import { useLoaderData, useRevalidator } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useSetAtom } from 'jotai';
import { notificationAtom } from "../../../atoms";

import { InputField } from "../../../Components/Forms";
import { Button, Card } from "../../../Components/UI";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Translate } from "../../../../I18N";
import { TwoFactorSetup } from "./Components/TwoFactorSetup";

const accountLoader =
(headers) =>
async () =>
UsersAPI.currentUser(new RequestParams({}, headers));

const Account = () => {
  const userAccount = useLoaderData();
  const [isSidepanelOpen, setIsSidepanelOpen] = useState(false);
  const setNotifications = useSetAtom(notificationAtom);
  const revalidator = useRevalidator();


  const {
    register,
    watch,
    handleSubmit,
    reset,
    formState: { errors, isSubmitted }
  } = useForm({
    defaultValues: userAccount,
    mode: 'onSubmit'
  });

  const submit = async (data) => {
    const { passwordConfirm } = data,userData = _objectWithoutProperties(data, _excluded);
    userData.password = userData.password ? userData.password : userAccount.password;
    await UsersAPI.save(new RequestParams(userData));
    await revalidator.revalidate();
    setNotifications({
      type: 'success',
      text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Account updated")
    });
  };

  useEffect(() => {
    reset(_objectSpread(_objectSpread({}, userAccount), {}, { password: '', passwordConfirm: '' }));
  }, [userAccount, reset]);

  return /*#__PURE__*/(
    _jsx("div", {
      className: "tw-content",
      style: { width: '100%', overflowY: 'auto' },
      "data-testid": "settings-account" }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Account" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx("form", { onSubmit: handleSubmit(submit), id: "account-form" }, void 0, /*#__PURE__*/
    _jsx(Card, { className: "mb-4", title: /*#__PURE__*/_jsx(Translate, {}, void 0, "General Information") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "grid gap-4 sm:grid-cols-2 sm:gap-6" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    _jsx(InputField, {
      id: "account-username",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Username"),
      value: userAccount.username,
      disabled: true }
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    _jsx(InputField, {
      id: "account-role",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "User Role"),
      value: userAccount.role,
      disabled: true }
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "col-span-2" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "account-email",
      hasErrors: !!errors.email,
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Email") },
    register('email', { required: true }))
    )
    )
    )
    ), /*#__PURE__*/
    _jsx(Card, { className: "mb-4", title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Change Password") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "grid gap-4 sm:grid-cols-2 sm:gap-6" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "new-password",
      hasErrors: !!errors.passwordConfirm,
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "New password") },
    register('password'), {
      type: "password" })
    ),
    errors.passwordConfirm && isSubmitted && /*#__PURE__*/
    _jsx("p", { className: "mt-2 text-sm text-error-600" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Passwords do not match")
    )

    ), /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "confirm-new-password",
      hasErrors: !!errors.passwordConfirm,
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Confirm new password") },
    register('passwordConfirm', { validate: (val) => val === watch('password') }), {
      type: "password" })
    )
    )
    )
    ),
    userAccount.using2fa ? /*#__PURE__*/
    _jsx(Card, {
      className: "mb-4",
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Two-Factor Authentication"),
      color: "default" }, void 0, /*#__PURE__*/

    _jsx("div", { className: "flex gap-6 items-center" }, void 0, /*#__PURE__*/
    _jsx(Button, { color: "success", disabled: true, className: "flex-none" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Activated")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 grow" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Your account's security is enhanced with two-factor authentication."

    )
    )
    )
    ) : /*#__PURE__*/

    _jsx(Card, {
      className: "mb-4",
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Two-Factor Authentication"),
      color: "yellow" }, void 0, /*#__PURE__*/

    _jsx("div", { className: "flex gap-6 items-center" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      styling: "outline",
      className: "flex-none",
      onClick: () => setIsSidepanelOpen(true) }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Enable")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 grow" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "You should activate this feature for enhanced account security."

    )
    )
    )
    )

    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx("a", {
      href: "/logout",
      "data-testid": "account-logout",
      className: "px-3 py-2 text-xs font-medium bg-white rounded-lg border hover:text-white text-error-600 border-error-600 hover:bg-error-800 hover:border-error-800 focus:outline-none focus:ring-4 focus:ring-indigo-200" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Logout")
    ), /*#__PURE__*/

    _jsx(Button, { type: "submit", form: "account-form" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Update")
    )
    )
    )
    ),

    userAccount.using2fa ? null : /*#__PURE__*/
    _jsx(TwoFactorSetup, { isOpen: isSidepanelOpen, closePanel: () => setIsSidepanelOpen(false) })

    ));

};

export { Account, accountLoader };